module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "chap-title"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Methodology")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It proved to be an enjoyable challenge to research the individual victims and their families from basic information for a time when few genealogical records are available. I have taken great care to verify the information used in this book, but I accept that I may have inadvertently ‘barked up the wrong tree’ in a few cases. However, the stories are based on records and are believable.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My first difficulty was assembling an accurate list of the seventy-three victims from various sources, which had different spellings of surnames and discrepancies in ages.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I was initially dependent on finding parish registers for baptisms, marriages, and burials (BMBs) on subscription websites and in archives. Civil registration of BMBs was introduced on 1 July 1837 but was not compulsory until 1874. Many parents could not afford both and avoided civil registration until it became a legal requirement; baptism was often delayed or arranged for several siblings together. All burials were in churchyards until Barnsley Cemetery opened in November 1861.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Before 1929, a couple had to be over 21 (‘full age’) to marry without parental consent. If they obtained permission the minimum age was 14 for boys and 12 for girls (‘minor’). This seems young to us, but in the early 1800s children were working in factories and collieries by that age.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The introduction of the General Registry Office (GRO) started too late to help with most records for victims, their siblings, parents and spouses, but has been invaluable for their children. BMDs for the Barnsley area were listed under Ecclesfield district until the end of March 1850 and this covered a wider area.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The 1841 Census, taken on 6 June, is the first with personal details and the only one to include the victims. Where these have survived, some writing is illegible, addresses are vague, surnames are spelt inconsistently, ages tend to have been rounded up or down, occupations can be unreliable, birthplaces are only shown for the county and "), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v("abbreviations were widely used. The 1851 Census for Barnsley suffered from water damage and many entries are no longer readable.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Unfortunately, few early records survive relating to Barnsley or Doncaster Poor Law Union and there are no Workhouse Admission Registers or Censuses for 1841 or 1851.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Wakefield Charities Coroners Notebooks only start in November 1852; they are not comprehensive with some periods missing, but those available are fascinating. I relied on contemporary newspapers for details about disasters and inquests, but the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Barnsley Chronicle")]), _vm._v(" was only established in 1858.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Principal Probate Registry was established on 12 January 1858 and keeps copies of Wills proved after 1858 in addition to Letters of Administration if intestate. It is much more difficult to find Wills prior to 1858, although it is highly unlikely that the colliery victims would have owned much to bequeath.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The South Yorkshire Miners’ Association was founded in 1858 and does not have colliery archives before this.")]), _vm._v(" "), _c('h4', {
    staticClass: "sub_level"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Writing Up Material")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As most victims and their families were baptised, lived, worked, got married and were buried in Barnsley town, I have usually only added the ‘township’ to addresses elsewhere.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I have provided names for the victims’ parents, siblings, spouses and children, including those who died in childhood, whenever I have been able to identify them. The same applies to information about when individuals died and where they were buried. When telling the stories of the victims’ grandchildren, I have provided more limited details unless they served in the First World War, were involved in other colliery disasters, or committed any crimes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I have indicated where I could prove connections between families. However, quite a few surnames kept cropping up, but I could not verify links in the time available.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Where I have written ‘in’ or ‘by’ the year, this means by the Census date, which was taken on the following Sundays:")]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "border"
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("6 June 1841")])]), _vm._v(" "), _c('td', {
    staticClass: "border"
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("30 March 1851")])]), _vm._v(" "), _c('td', {
    staticClass: "border"
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("7 April 1861")])]), _vm._v(" "), _c('td', {
    staticClass: "border1"
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("2 April 1871")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "bordera"
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("3 April 1881")])]), _vm._v(" "), _c('td', {
    staticClass: "bordera"
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("5 April 1891")])]), _vm._v(" "), _c('td', {
    staticClass: "bordera"
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("31 March 1901")])]), _vm._v(" "), _c('td', {
    staticClass: "border2"
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("2 April 1911"), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#sfn1",
      "id": "fn1"
    }
  }, [_vm._v("*")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "sources"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#fn1",
      "id": "sfn1"
    }
  }, [_vm._v("*")]), _vm._v(" includes total children born, how many alive and how many dead (for women)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("The 1921 Census is not publicly available until 2022. As the 1931 Census was destroyed by fire during the Second World War and there was no 1941 Census, the 1939 Register, collected on Friday 29 September to produce identity cards, provides the only record between 1921 and 1951.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I have quoted many occupations from the Censuses, some of which are unfamiliar, because I wanted to add some flavour from the enumerators who completed them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Measuringworth.com calculates relative values and the most recent year is 2019. I mostly used ‘labour value’ from its range, which is one of the lowest, but I have indicated if based on Retail Price Index (RPI).")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0004-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Simplified map of Barnsley c.1847. (Paul Ainsworth)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1006a592","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Chapter01.vue
// module id = 78
// module chunks = 0